import { ActionTypes } from '../actions';

const SendSearchReducer = (state = "", action) => {
  switch (action.type) {
    case ActionTypes.SENDSEARCH:
      return action.payload;
    default:
      return state;
  }
};

export default SendSearchReducer;
